import { Component, inject, Inject, signal, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';
import { MatCardModule } from '@angular/material/card';
import { CarouselModule } from 'ngx-owl-carousel-o';
@Component({
  selector: 'lib-web-shared-ui-lib-gallery-view-img-popup',
  imports: [MatDialogModule, MatButtonModule, MatCardModule, CarouselModule],
  templateUrl: './lib-gallery-view-img-popup.component.html',
  styleUrl: './lib-gallery-view-img-popup.component.scss',
})
export class LibGalleryViewImgPopupComponent implements AfterViewInit {
  private readonly loggingService = inject(LoggingService);
  public readonly replaceBucket = new ReplaceBucket();

  indexImageSignal = signal<number>(0);

  carouselOptions = {
    loop: true,
    nav: true, // Enable navigation
    dots: false,
    lazyLoad: true,
    autoplay: false,
    autoplayTimeout: 3000,
    startPosition: 0,
    navText: ['<i class="fa fa-angle-left" style="align-content:center;"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: {
        items: 1, // Show 1.5 items on smaller screens
        // stagePadding: 10,
      },
    },
  };

  ngAfterViewInit() {
    this.loggingService.warn('@@@ carousel popup resize@@@');

    setTimeout(() => {
      this.loggingService.warn('@@@ carousel popup resize@@@ setTimeout');
      window.dispatchEvent(new Event('resize'));
    });
  }
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { url: string; startPosition: number },
    private dialogRef: MatDialogRef<LibGalleryViewImgPopupComponent>
  ) {
    // data.url = this.findVideoId(data.url);
    this.urlImg.set(data.url);
    this.indexImageSignal.set(data.startPosition);

    // Update carousel options with the correct start position
    this.carouselOptions = {
      ...this.carouselOptions,
      startPosition: data.startPosition || 0,
      loop: false,
    };

    this.loggingService.warn('urlImg', this.urlImg());
    console.log('data;', data);
    console.log('this.urlImg', this.urlImg());
    console.log('=== Gallery Dialog Carousel Settings ===');
    console.log('Starting at index:', data.startPosition);
    console.log('Total images:', Array.isArray(data.url) ? data.url.length : 1);
    console.log('Carousel startPosition:', this.carouselOptions.startPosition);
    console.log('======================================');
  }

  urlImg = signal<string>('');
  // findVideoId(url: string) {
  //   return url.split('/')[3].split('?')[0];
  // }
  closeDialog(productId: string) {
    this.dialogRef.close(productId);
  }
}
